import apiClient from './apiClient';

const API_URL = '/cobros';

// Listado paginado con filtros (usado por los 3 listados de cobranzas: Favorables, Altas, Deudores)
// archivado: undefined = todos; false = sin archivar (Altas); true = solo los archivados (V269).
export const getCobros = async (estado, texto, page = 0, size = 25, sort = 'creadoEn,desc', archivado, extra = {}) => {
    const params = { page, size, sort };
    if (archivado !== undefined && archivado !== null) params.archivado = archivado;
    // extra: { vista: 'DEUDORES' | 'ALTAS', migrado: true | false, mesPlanilla: 'aaaa-mm-01' } (V273)
    Object.entries(extra).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') params[k] = v; });
    if (estado) params.estado = estado;
    if (texto && String(texto).trim() !== '') params.texto = String(texto).trim();
    const response = await apiClient.get(API_URL, { params });
    return response.data;
};

// Contadores por estado, para los badges del menú
export const getResumenCobranzas = async () => {
    const response = await apiClient.get(`${API_URL}/resumen`);
    return response.data;
};

export const getCobroPorId = async (idCobro) => {
    const response = await apiClient.get(`${API_URL}/${idCobro}`);
    return response.data;
};

// El cobro vigente de un trámite, para la tarjeta en su ficha. null si todavía no tiene.
export const getCobroPorTramite = async (idTramite) => {
    const response = await apiClient.get(`${API_URL}/por-tramite/${idTramite}`);
    return response.status === 204 ? null : response.data;
};

export const getCobrosPorCliente = async (cuil) => {
    const response = await apiClient.get(`${API_URL}/por-cliente/${cuil}`);
    return response.data;
};

// Alta manual (cliente solo, o con trámites)
export const crearCobro = async (dto) => {
    const response = await apiClient.post(API_URL, dto);
    return response.data;
};

// Editar pacto / monto / banco / observaciones
export const editarCobro = async (idCobro, dto) => {
    const response = await apiClient.put(`${API_URL}/${idCobro}`, dto);
    return response.data;
};

// Registrar la fecha de alta del beneficio -> A_COBRAR pasa a ALTA
export const registrarAltaCobro = async (idCobro, fechaAlta) => {
    const response = await apiClient.post(`${API_URL}/${idCobro}/alta`, { fechaAlta });
    return response.data;
};

// ── Deudores de la planilla (V273): por mes, recordatorio y cierre ──
export const getMesesDeudoresPlanilla = async () => {
    const response = await apiClient.get(`${API_URL}/deudores-planilla/meses`);
    return response.data;
};

// { ids } o { mes: 'aaaa-mm-01' }, y activo: true | false
export const cambiarRecordatorioDeudores = async (seleccion) => {
    const response = await apiClient.post(`${API_URL}/deudores-planilla/recordatorio`, seleccion);
    return response.data;
};

// Dar por cerradas: a Archivo y de baja con motivo (salen de Deudores)
export const cerrarDeudoresPlanilla = async (seleccion) => {
    const response = await apiClient.post(`${API_URL}/deudores-planilla/cerrar`, seleccion);
    return response.data;
};

export const reabrirDeudorPlanilla = async (idCobro) => {
    const response = await apiClient.post(`${API_URL}/deudores-planilla/${idCobro}/reabrir`);
    return response.data;
};

// Volver de Altas a Favorables: quita la fecha de alta (sin pagos ni plan de cuotas todavía)
export const quitarAltaCobro = async (idCobro) => {
    const response = await apiClient.delete(`${API_URL}/${idCobro}/alta`);
    return response.data;
};

// Crear o reprogramar el plan de cuotas
export const crearOReprogramarPlanCuotas = async (idCobro, cuotas) => {
    const response = await apiClient.post(`${API_URL}/${idCobro}/plan-cuotas`, { cuotas });
    return response.data;
};

// Registrar pago (o entrega inicial)
export const registrarPagoCobro = async (idCobro, pago) => {
    const response = await apiClient.post(`${API_URL}/${idCobro}/pagos`, pago);
    return response.data;
};

// Anular un pago cargado mal
export const anularPagoCobro = async (idCobro, idPago) => {
    const response = await apiClient.delete(`${API_URL}/${idCobro}/pagos/${idPago}`);
    return response.data;
};

// Anotar llamado / WhatsApp / nota de cobranza
export const registrarGestionCobro = async (idCobro, gestion) => {
    const response = await apiClient.post(`${API_URL}/${idCobro}/gestiones`, gestion);
    return response.data;
};

// Dar de baja con motivo
// Interruptor de la atención de cobro: 'UN_SOLO_PAGO' (pagó todo, queda pagado) o 'EN_CUOTAS'.
export const definirTipoPagoCobro = async (idCobro, tipoPago) =>
    (await apiClient.post(`${API_URL}/${idCobro}/tipo-pago`, { tipoPago })).data;

// Pasar a Archivo / sacar de archivo (V269): con alta, aunque quede saldo en cuotas.
export const archivarCobro = async (idCobro) => (await apiClient.post(`${API_URL}/${idCobro}/archivo`)).data;
export const sacarCobroDeArchivo = async (idCobro) => (await apiClient.delete(`${API_URL}/${idCobro}/archivo`)).data;

export const darDeBajaCobro = async (idCobro, motivo) => {
    const response = await apiClient.post(`${API_URL}/${idCobro}/baja`, { motivo });
    return response.data;
};

// ── Recordatorios de cuota (V263) ──────────────────────────────────────────

// El recordatorio de cuota vencida tal como saldría, con el último que se le mandó.
export const getVistaPreviaRecordatorioVencida = async (idCobro) => {
    const response = await apiClient.get(`${API_URL}/${idCobro}/recordatorio-vencida`);
    return response.data;
};

// Lo manda por WhatsApp y lo deja en la bitácora. Devuelve { quedoEnCola }.
export const recordarCuotaVencida = async (idCobro, mensaje) => {
    const response = await apiClient.post(`${API_URL}/${idCobro}/recordatorio-vencida`, { mensaje });
    return response.data;
};

// { diasAntes, plantillaProxima, plantillaVencida }
export const getConfiguracionRecordatorioCuotas = async () => {
    const response = await apiClient.get('/configuracion/recordatorio-cuotas');
    return response.data;
};

export const guardarConfiguracionRecordatorioCuotas = async (configuracion) => {
    const response = await apiClient.put('/configuracion/recordatorio-cuotas', configuracion);
    return response.data;
};
